var pLon=new Array(48); /* birth place longitude [deg,min]  */
var pLat=new Array(48); /* birth place latitude  [deg,min]  */
pLon[ 1]=8481; pLat[ 1]=2584; /* 北海道 */
pLon[ 2]=8445; pLat[ 2]=2449; /* 青森県 */
pLon[ 3]=8469; pLat[ 3]=2382; /* 岩手県 */
pLon[ 4]=8453; pLat[ 4]=2296; /* 宮城県 */
pLon[ 5]=8406; pLat[ 5]=2383; /* 秋田県 */
pLon[ 6]=8422; pLat[ 6]=2294; /* 山形県 */
pLon[ 7]=8428; pLat[ 7]=2265; /* 福島県 */
pLon[ 8]=8429; pLat[ 8]=2182; /* 茨城県 */
pLon[ 9]=8393; pLat[ 9]=2194; /* 栃木県 */
pLon[10]=8344; pLat[10]=2183; /* 群馬県 */
pLon[11]=8379; pLat[11]=2151; /* 埼玉県 */
pLon[12]=8408; pLat[12]=2136; /* 千葉県 */
pLon[13]=8386; pLat[13]=2140; /* 東京都 */
pLon[14]=8379; pLat[14]=2127; /* 神奈川県 */
pLon[15]=8342; pLat[15]=2274; /* 新潟県 */
pLon[16]=8233; pLat[16]=2202; /* 富山県 */
pLon[17]=8200; pLat[17]=2194; /* 石川県 */
pLon[18]=8173; pLat[18]=2164; /* 福井県 */
pLon[19]=8314; pLat[19]=2140; /* 山梨県 */
pLon[20]=8291; pLat[20]=2199; /* 長野県 */
pLon[21]=8204; pLat[21]=2123; /* 岐阜県 */
pLon[22]=8303; pLat[22]=2098; /* 静岡県 */
pLon[23]=8215; pLat[23]=2111; /* 愛知県 */
pLon[24]=8191; pLat[24]=2084; /* 三重県 */
pLon[25]=8152; pLat[25]=2100; /* 滋賀県 */
pLon[26]=8146; pLat[26]=2101; /* 京都府 */
pLon[27]=8131; pLat[27]=2081; /* 大阪府 */
pLon[28]=8111; pLat[28]=2081; /* 兵庫県 */
pLon[29]=8150; pLat[29]=2081; /* 奈良県 */
pLon[30]=8110; pLat[30]=2053; /* 和歌山県 */
pLon[31]=8054; pLat[31]=2130; /* 鳥取県 */
pLon[32]=7983; pLat[32]=2128; /* 島根県 */
pLon[33]=8036; pLat[33]=2079; /* 岡山県 */
pLon[34]=7948; pLat[34]=2064; /* 広島県 */
pLon[35]=7889; pLat[35]=2051; /* 山口県 */
pLon[36]=8074; pLat[36]=2044; /* 徳島県 */
pLon[37]=8043; pLat[37]=2060; /* 香川県 */
pLon[38]=7966; pLat[38]=2030; /* 愛媛県 */
pLon[39]=8012; pLat[39]=2013; /* 高知県 */
pLon[40]=7825; pLat[40]=2016; /* 福岡県 */
pLon[41]=7818; pLat[41]=1995; /* 佐賀県 */
pLon[42]=7793; pLat[42]=1964; /* 長崎県 */
pLon[43]=7845; pLat[43]=1967; /* 熊本県 */
pLon[44]=7897; pLat[44]=1994; /* 大分県 */
pLon[45]=7886; pLat[45]=1914; /* 宮崎県 */
pLon[46]=7834; pLat[46]=1896; /* 鹿児島県 */
pLon[47]=7661; pLat[47]=1572; /* 沖縄県 */

var tAsp=new Array(12); /* aspect sign */
tAsp[ 0]="";
tAsp[ 1]="♂"; /*   0 conjunction */
tAsp[ 2]="∨"; /*  30 semi-sextile */
tAsp[ 3]="∠"; /*  45 semi-square */
tAsp[ 4]="＊"; /*  60 sextile */
tAsp[ 5]="Ｑ"; /*  72 quintile */
tAsp[ 6]="□"; /*  90 square */
tAsp[ 7]="△"; /* 120 trine */
tAsp[ 8]="Φ"; /* 135 sesquiquadrate */
tAsp[ 9]="∧"; /* 150 quincunx */
tAsp[10]="∞"; /* 180 opposition */
tAsp[11]="∥"; /*     parallel */

var tSgn=new Array(12);
tSgn[ 0]="aries";
tSgn[ 1]="taurus";
tSgn[ 2]="gemini";
tSgn[ 3]="cancer";
tSgn[ 4]="leo";
tSgn[ 5]="virgo";
tSgn[ 6]="libra";
tSgn[ 7]="scorpius";
tSgn[ 8]="sagittarius";
tSgn[ 9]="capricornus";
tSgn[10]="aquarius";
tSgn[11]="pisces";

var p1 ,p2 ,p3 ,p4 ,p5 ,p6 ,p7 ,p8 ,p9 ,p10,
    p11,p12,p13,p14,p15,p16,p17,p18,p19,p20,
    p21,p22,p23,p24,p25,p26,p27,p28,p29,p30,
    p31,p32,p33, p99, pt; /* planet parameter */
var cl,cb,rv; /* planet position work */

var pcl=new Array(22); /* planet & casp celestial longitude */
var pcb=new Array(10); /* planet celestial latitude */

function Sind(x){return Math.sin((x)*Math.PI/180)}
function Cosd(x){return Math.cos((x)*Math.PI/180)}

/*******************************************
* current time set sub                     *
*   input  : nothing                       *
*   output : nothing                       *
*******************************************/
function nowset()
{
  var today=new Date();
  var iYear=today.getYear();
  if(iYear<2000) iYear+=1900

  document.Fin.iYear.value=iYear;
  document.Fin.iMonth.value=today.getMonth()+1;
  document.Fin.iDay.value=today.getDate();
  document.Fin.iHour.value=today.getHours();
  document.Fin.iMinute.value=today.getMinutes();
}

/*******************************************
* planet parameter cal sub                 *
*   input  : jd = julian day               *
*   output : p1-p33,p99 = planet parameter *
*            pt = time parameter           *
*******************************************/

function Get_pr1(jd)
{
  var tt;

  tt=jd-2451545;
  pt=tt/36525+1;

  p1 =0.606434+0.03660110129*tt; /* mean longitude of moon */
  p1 =(p1-Math.floor(p1))*2*Math.PI;
  p2 =0.374897+0.03629164709*tt; /* mean anomary of moon */
  p2 =(p2-Math.floor(p2))*2*Math.PI;
  p3 =0.259091+0.03674819520*tt; /* argument of latitude of moon */
  p3 =(p3-Math.floor(p3))*2*Math.PI;
  p4 =0.827362+0.03386319198*tt; /* mean elongation of moon from sun */
  p4 =(p4-Math.floor(p4))*2*Math.PI;
  p5 =0.347343 - 0.00014709391*tt; /* longitude of moon ascending node */
  p5 =(p5-Math.floor(p5))*2*Math.PI;
  p7 =0.779072+0.00273790931*tt; /* mean longitude of sun */
  p7 =(p7-Math.floor(p7))*2*Math.PI;
  p8 =0.993126+0.00273777850*tt; /* mean anomary of sun */
  p8 =(p8-Math.floor(p8))*2*Math.PI;
  p9 =0.700695+0.01136771400*tt; /* mean longitude of mercury */
  p9 =(p9-Math.floor(p9))*2*Math.PI;
  p10=0.485541+0.01136759566*tt; /* mean anomary of mercury */
  p10=(p10-Math.floor(p10))*2*Math.PI;
  p11=0.566441+0.01136762384*tt; /* argument of latitude of sun */
  p11=(p11-Math.floor(p11))*2*Math.PI;
  p12=0.505498+0.00445046867*tt; /* mean longitude of venus */
  p12=(p12-Math.floor(p12))*2*Math.PI;
  p13=0.140023+0.00445036173*tt; /* mean anomary of venus */
  p13=(p13-Math.floor(p13))*2*Math.PI;
  p14=0.292498+0.00445040017*tt; /* argument of latitude of venus */
  p14=(p14-Math.floor(p14))*2*Math.PI;
  p15=0.987353+0.00145575328*tt; /* mean longitude of mars */
  p15=(p15-Math.floor(p15))*2*Math.PI;
  p16=0.053856+0.00145561327*tt; /* mean anomary of mars */
  p16=(p16-Math.floor(p16))*2*Math.PI;
  p17=0.849694+0.00145569465*tt; /* argument of latitude of mars */
  p17=(p17-Math.floor(p17))*2*Math.PI;
  p18=0.089608+0.00023080893*tt; /* mean longitude of jupiter */
  p18=(p18-Math.floor(p18))*2*Math.PI;
  p19=0.056531+0.00023080893*tt; /* mean anomary of jupiter */
  p19=(p19-Math.floor(p19))*2*Math.PI;
  p20=0.814794+0.00023080893*tt; /* argument of latitude of jupiter */
  p20=(p20-Math.floor(p20))*2*Math.PI;
  p21=0.133295+0.00009294371*tt; /* mean longitude of saturn */
  p21=(p21-Math.floor(p21))*2*Math.PI;
  p22=0.882987+0.00009294371*tt; /* mean anomary of saturn */
  p22=(p22-Math.floor(p22))*2*Math.PI;
  p23=0.821218+0.00009294371*tt; /* argument of latitude of saturn */
  p23=(p23-Math.floor(p23))*2*Math.PI;
  p24=0.870169+0.00003269438*tt; /* mean longitude of uranus */
  p24=(p24-Math.floor(p24))*2*Math.PI;
  p25=0.400589+0.00003269438*tt; /* mean anomary of uranus */
  p25=(p25-Math.floor(p25))*2*Math.PI;
  p26=0.664614+0.00003265562*tt; /* argument of latitude of uranus */
  p26=(p26-Math.floor(p26))*2*Math.PI;
  p27=0.846912+0.00001672092*tt; /* mean longitude of neptune */
  p27=(p27-Math.floor(p27))*2*Math.PI;
  p28=0.725368+0.00001672092*tt; /* mean anomary of neptune */
  p28=(p28-Math.floor(p28))*2*Math.PI;
  p29=0.480856+0.00001663715*tt; /* argument of latitude of neptune */
  p29=(p29-Math.floor(p29))*2*Math.PI;
  p31=0.663854+0.00001115482*tt; /* mean longitude of pluto */
  p31=(p31-Math.floor(p31))*2*Math.PI;
  p32=0.041020+0.00001104864*tt; /* mean anomary of pluto */
  p32=(p32-Math.floor(p32))*2*Math.PI;
  p33=0.357355+0.00001104864*tt; /* argument of latitude of pluto */
  p33=(p33-Math.floor(p33))*2*Math.PI;

  p99=(1934*pt-1789)/360;
  p99=(p99-Math.floor(p99))*2*Math.PI;
}

/*************************************
* sun position caliculate sub 1      *
*   (geocentric ecliptic)            *
*  output : cl = longitude [sec,deg] *
*           cb = latitude  [sec,deg] *
*           rv = radius    [AU]      *
*************************************/

function Sun_cal1()
{
  cl =1296000*p7/Math.PI/2;
  cl+=   6910*Math.sin(p8);
  cl+=     72*Math.sin(2*p8);
  cl-=     17*pt*Math.sin(p8);
  cl-=      7*Math.cos(p8-p19);
  cl+=      6*Math.sin(p1-p7);
  cl+=      5*Math.sin(4*p8-8*p16+3*p19);
  cl-=      5*Math.cos(2*p8-2*p13);
  cl-=      4*Math.sin(p8-p13);
  cl+=      4*Math.cos(4*p8-8*p16+3*p19);
  cl+=      3*Math.sin(2*p8-2*p13);
  cl-=      3*Math.sin(p19);
  cl-=      3*Math.sin(2*p8-2*p19);

  cb=0;

  rv =1.00014;
  rv-=0.01675*Math.cos(p8);
  rv-=0.00014*Math.cos(2*p8);
}

/**************************
* moon position cal sub 1 *
*   (geocentric ecliptic) *
**************************/

function Moon_cal1()
{
  cl =1296000*p1/Math.PI/2;
  cl+=  22640*Math.sin(p2);
  cl-=   4586*Math.sin(p2-2*p4);
  cl+=   2370*Math.sin(2*p4);
  cl+=    769*Math.sin(2*p2);
  cl-=    668*Math.sin(p8);
  cl-=    412*Math.sin(2*p3);
  cl-=    212*Math.sin(2*p2-2*p4);
  cl-=    206*Math.sin(p2-2*p4+p8);
  cl+=    192*Math.sin(p2+2*p4);
  cl+=    165*Math.sin(2*p4-p8);
  cl+=    148*Math.sin(p2-p8);
  cl-=    125*Math.sin(p4);
  cl-=    110*Math.sin(p2+p8);
  cl-=     55*Math.sin(2*p3-2*p4);
  cl-=     45*Math.sin(p2+2*p3);
  cl+=     40*Math.sin(p2-2*p3);
  cl-=     38*Math.sin(p2-4*p4);
  cl+=     36*Math.sin(3*p2);
  cl-=     31*Math.sin(2*p2-4*p4);
  cl+=     28*Math.sin(p2-2*p4-p8);
  cl-=     24*Math.sin(2*p4+p8);
  cl+=     19*Math.sin(p2-p4);
  cl+=     18*Math.sin(p4+p8);
  cl+=     15*Math.sin(p2+2*p4-p8);
  cl+=     14*Math.sin(2*p2+2*p4);
  cl+=     14*Math.sin(4*p4);
  cl-=     13*Math.sin(3*p2-2*p4);
  cl-=     11*Math.sin(p2+16*p7-18*p12);
  cl+=     10*Math.sin(2*p2-p8);
  cl+=      9*Math.sin(p2-2*p3-2*p4);
  cl+=      9*Math.cos(p2+16*p7-18*p12);
  cl-=      9*Math.sin(2*p2-2*p4+p8);
  cl-=      8*Math.sin(p2+p4);
  cl+=      8*Math.sin(2*p4-2*p8);
  cl-=      8*Math.sin(2*p2+p8);
  cl-=      7*Math.sin(2*p8);
  cl-=      7*Math.sin(p2-2*p4+2*p8);
  cl+=      7*Math.sin(p5);
  cl-=      6*Math.sin(p2-2*p3+2*p4);
  cl-=      6*Math.sin(2*p3+2*p4);
  cl-=      4*Math.sin(p2-4*p4+p8);
  cl+=      4*pt*Math.cos(p2+16*p7-18*p12);
  cl-=      4*Math.sin(2*p2+2*p3);
  cl+=      4*pt*Math.sin(p2+16*p7-18*p12);
  cl+=      3*Math.sin(p2-3*p4);
  cl-=      3*Math.sin(p2+2*p4+p8);
  cl-=      3*Math.sin(2*p2-4*p4+p8);
  cl+=      3*Math.sin(p2-2*p8);
  cl+=      3*Math.sin(p2-2*p4-2*p8);
  cl-=      2*Math.sin(2*p2-2*p4-p8);
  cl-=      2*Math.sin(2*p3-2*p4+p8);
  cl+=      2*Math.sin(p2+4*p4);
  cl+=      2*Math.sin(4*p2);
  cl+=      2*Math.sin(4*p4-p8);
  cl+=      2*Math.sin(2*p2-p4);

  cb =18461*Math.sin(p3);
  cb+= 1010*Math.sin(p2+p3);
  cb+= 1000*Math.sin(p2-p3);
  cb-=  624*Math.sin(p3-2*p4);
  cb-=  199*Math.sin(p2-p3-2*p4);
  cb-=  167*Math.sin(p2+p3-2*p4);
  cb+=  117*Math.sin(p3+2*p4);
  cb+=   62*Math.sin(2*p2+p3);
  cb+=   33*Math.sin(p2-p3+2*p4);
  cb+=   32*Math.sin(2*p2-p3);
  cb-=   30*Math.sin(p3-2*p4+p8);
  cb-=   16*Math.sin(2*p2+p3-2*p4);
  cb+=   15*Math.sin(p2+p3+2*p4);
  cb+=   12*Math.sin(p3-2*p4-p8);
  cb-=    9*Math.sin(p2-p3-2*p4+p8);
  cb-=    8*Math.sin(p3+p5);
  cb+=    8*Math.sin(p3+2*p4-p8);
  cb-=    7*Math.sin(p2+p3-2*p4+p8);
  cb+=    7*Math.sin(p2+p3-p8);
  cb-=    7*Math.sin(p2+p3-4*p4);
  cb-=    6*Math.sin(p3+p8);
  cb-=    6*Math.sin(3*p3);
  cb+=    6*Math.sin(p2-p3-p8);
  cb-=    5*Math.sin(p3+p4);
  cb-=    5*Math.sin(p2+p3+p8);
  cb-=    5*Math.sin(p2-p3+p8);
  cb+=    5*Math.sin(p3-p8);
  cb+=    5*Math.sin(p3-p4);
  cb+=    4*Math.sin(3*p2+p3);
  cb-=    4*Math.sin(p3-4*p4);
  cb-=    3*Math.sin(p2-p3-4*p4);
  cb+=    3*Math.sin(p2-3*p3);
  cb-=    2*Math.sin(2*p2-p3-4*p4);
  cb-=    2*Math.sin(3*p3-2*p4);
  cb+=    2*Math.sin(2*p2-p3+2*p4);
  cb+=    2*Math.sin(p2-p3+2*p4-p8);
  cb+=    2*Math.sin(2*p2-p3-2*p4);
  cb+=    2*Math.sin(3*p2-p3);
}

/*****************************
* mercury position cal sub 1 *
*   (heriocentric ecliptic)  *
*****************************/

function Mercury_cal1()
{
  cl =1296000*p9/Math.PI/2;
  cl+=  84378*Math.sin(p10);
  cl+=  10733*Math.sin(2*p10);
  cl+=   1892*Math.sin(3*p10);
  cl-=    646*Math.sin(2*p11);
  cl+=    381*Math.sin(4*p10);
  cl-=    306*Math.sin(p10-2*p11);
  cl-=    274*Math.sin(p10+2*p11);
  cl-=     92*Math.sin(2*p10+2*p11);
  cl+=     83*Math.sin(5*p10);
  cl-=     28*Math.sin(3*p10+2*p11);
  cl+=     25*Math.sin(2*p10-2*p11);
  cl+=     19*Math.sin(6*p10);
  cl-=      9*Math.sin(4*p10+2*p11);
  cl+=      8*pt*Math.sin(p10);
  cl+=      7*Math.cos(2*p10-5*p13);

  cb =24134*Math.sin(p11);
  cb+= 5180*Math.sin(p10-p11);
  cb+= 4910*Math.sin(p10+p11);
  cb+= 1124*Math.sin(2*p10+p11);
  cb+=  271*Math.sin(3*p10+p11);
  cb+=  132*Math.sin(2*p10-p11);
  cb+=   67*Math.sin(4*p10+p11);
  cb+=   18*Math.sin(3*p10-p11);
  cb+=   17*Math.sin(5*p10+p11);
  cb-=   10*Math.sin(3*p11);
  cb-=    9*Math.sin(p10-3*p11);

  rv =0.39528;
  rv-=0.07834*Math.cos(p10);
  rv-=0.00795*Math.cos(2*p10);
  rv-=0.00121*Math.cos(3*p10);
  rv-=0.00022*Math.cos(4*p10);
}

/***************************
* venus position cal sub 1 *
***************************/

function Venus_cal1()
{
  cl =1296000*p12/Math.PI/2;
  cl+=   2814*Math.sin(p13);
  cl-=    181*Math.sin(2*p14);
  cl-=     20*pt*Math.sin(p13);
  cl+=     12*Math.sin(2*p13);
  cl-=     10*Math.cos(2*p8-2*p13);
  cl+=      7*Math.cos(3*p8-3*p13);

  cb =12215*Math.sin(p14);
  cb+=   83*Math.sin(p13+p14);
  cb+=   83*Math.sin(p13-p14);

  rv =0.72335;
  rv-=0.00493*Math.cos(p13);
}

/**************************
* mars position cal sub 1 *
**************************/

function Mars_cal1()
{
  cl =1296000*p15/Math.PI/2;
  cl+=  38451*Math.sin(p16);
  cl+=   2238*Math.sin(2*p16);
  cl+=    181*Math.sin(3*p16);
  cl-=     52*Math.sin(2*p17);
  cl+=     37*pt*Math.sin(p16);
  cl-=     22*Math.cos(p16-2*p19);
  cl-=     19*Math.sin(p16-p19);
  cl+=     17*Math.cos(p16-p19);
  cl+=     17*Math.sin(4*p16);
  cl-=     16*Math.cos(2*p16-2*p19);
  cl+=     13*Math.cos(p8-2*p16);
  cl-=     10*Math.sin(p16-2*p17);
  cl-=     10*Math.sin(p16+2*p17);
  cl+=      7*Math.cos(p8-p16);
  cl-=      7*Math.cos(2*p8-3*p16);
  cl-=      5*Math.sin(p13-3*p16);
  cl-=      5*Math.sin(p8-p16);
  cl-=      5*Math.sin(p8-2*p16);
  cl-=      4*Math.cos(2*p8-4*p16);
  cl+=      4*pt*Math.sin(2*p16);
  cl+=      4*Math.cos(p19);
  cl+=      3*Math.cos(p13-3*p16);
  cl+=      3*Math.sin(2*p16-2*p19);

  cb =6603*Math.sin(p17);
  cb+= 622*Math.sin(p16-p17);
  cb+= 615*Math.sin(p16+p17);
  cb+=  64*Math.sin(2*p16+p17);

  rv =1.53031;
  rv-=0.14170*Math.cos(p16);
  rv-=0.00660*Math.cos(2*p16);
  rv-=0.00047*Math.cos(3*p16);
}

/*****************************
* jupiter position cal sub 1 *
*****************************/

function Jupiter_cal1()
{
  cl =1296000*p18/Math.PI/2;
  cl+=  19934*Math.sin(p19);
  cl+=   5023*pt;
  cl+=   2511;
  cl+=   1093*Math.cos(2*p19-5*p22);
  cl+=    601*Math.sin(2*p19);
  cl-=    479*Math.sin(2*p19-5*p22);
  cl-=    185*Math.sin(2*p19-2*p22);
  cl+=    137*Math.sin(3*p19-5*p22);
  cl-=    131*Math.sin(p19-2*p22);
  cl+=     79*Math.cos(p19-p22);
  cl-=     76*Math.cos(2*p19-2*p22);
  cl-=     74*pt*Math.cos(p19);
  cl+=     68*pt*Math.sin(p19);
  cl+=     66*Math.cos(2*p19-3*p22);
  cl+=     63*Math.cos(3*p19-5*p22);
  cl+=     53*Math.cos(p19-5*p22);
  cl+=     49*Math.sin(2*p19-3*p22);
  cl-=     43*pt*Math.sin(2*p19-5*p22);
  cl-=     37*Math.cos(p19);
  cl+=     25*Math.sin(2*p18);
  cl+=     25*Math.sin(3*p19);
  cl-=     23*Math.sin(p19-5*p22);
  cl-=     19*pt*Math.cos(2*p19-5*p22);
  cl+=     17*Math.cos(2*p19-4*p22);
  cl+=     17*Math.cos(3*p19-3*p22);
  cl-=     14*Math.sin(p19-p22);
  cl-=     13*Math.sin(3*p19-4*p22);
  cl-=      9*Math.cos(2*p18);
  cl+=      9*Math.cos(p22);
  cl-=      9*Math.sin(p22);
  cl-=      9*Math.sin(3*p19-2*p22);
  cl+=      9*Math.sin(4*p19-5*p22);
  cl+=      9*Math.sin(2*p19-6*p22+3*p25);
  cl-=      8*Math.cos(4*p19-10*p22);
  cl+=      7*Math.cos(3*p19-4*p22);
  cl-=      7*Math.cos(p19-3*p22);
  cl-=      7*Math.sin(4*p19-10*p22);
  cl-=      7*Math.sin(p19-3*p22);
  cl+=      6*Math.cos(4*p19-5*p22);
  cl-=      6*Math.sin(3*p19-3*p22);
  cl+=      5*Math.cos(2*p22);
  cl-=      4*Math.sin(4*p19-4*p22);
  cl-=      4*Math.cos(3*p22);
  cl+=      4*Math.cos(2*p19-p22);
  cl-=      4*Math.cos(3*p19-2*p22);
  cl-=      4*pt*Math.cos(2*p19);
  cl+=      3*pt*Math.sin(2*p19);
  cl+=      3*Math.cos(5*p22);
  cl+=      3*Math.cos(5*p19-10*p22);
  cl+=      3*Math.sin(2*p22);
  cl-=      2*Math.sin(2*p18-p19);
  cl+=      2*Math.sin(2*p18+p19);
  cl-=      2*pt*Math.sin(3*p19-5*p22);
  cl-=      2*pt*Math.sin(p19-5*p22);

  cb =-4692*Math.cos(p19);
  cb+=  259*Math.sin(p19);
  cb+=  227;
  cb-=  227*Math.cos(2*p19);
  cb+=   30*pt*Math.sin(p19);
  cb+=   21*pt*Math.cos(p19);
  cb+=   16*Math.sin(3*p19-5*p22);
  cb-=   13*Math.sin(p19-5*p22);
  cb-=   12*Math.cos(3*p19);
  cb+=   12*Math.sin(2*p19);
  cb+=    7*Math.cos(3*p19-5*p22);
  cb-=    5*Math.cos(p19-5*p22);

  rv =5.20883;
  rv-=0.25122*Math.cos(p19);
  rv-=0.00604*Math.cos(2*p19);
  rv+=0.00260*Math.cos(2*p19-2*p22);
  rv-=0.00170*Math.cos(3*p19-5*p22);
  rv-=0.00106*Math.sin(2*p19-2*p22);
  rv-=0.00091*pt*Math.sin(p19);
  rv-=0.00084*pt*Math.cos(p19);
  rv+=0.00069*Math.sin(2*p19-3*p22);
  rv-=0.00067*Math.sin(p19-5*p22);
  rv+=0.00066*Math.sin(3*p19-5*p22);
  rv+=0.00063*Math.sin(p19-p22);
  rv-=0.00051*Math.cos(2*p19-3*p22);
  rv-=0.00046*Math.sin(p19);
  rv-=0.00029*Math.cos(p19-5*p22);
  rv+=0.00027*Math.cos(p19-2*p22);
  rv-=0.00022*Math.cos(3*p19);
  rv-=0.00021*Math.sin(2*p19-5*p22);
}

/****************************
* saturn position cal sub 1 *
****************************/

function Saturn_cal1()
{
  cl =1296000*p21/Math.PI/2;
  cl+=  23045*Math.sin(p22);
  cl+=   5014*pt;
  cl-=   2689*Math.cos(2*p19-5*p22);
  cl+=   2507;
  cl+=   1177*Math.sin(2*p19-5*p22);
  cl-=    826*Math.cos(2*p19-4*p22);
  cl+=    802*Math.sin(2*p22);
  cl+=    425*Math.sin(p19-2*p22);
  cl-=    229*pt*Math.cos(p22);
  cl-=    153*Math.cos(2*p19-6*p22);
  cl-=    142*pt*Math.sin(p22);
  cl-=    114*Math.cos(p22);
  cl+=    101*pt*Math.sin(2*p19-5*p22);
  cl-=     70*Math.cos(2*p21);
  cl+=     67*Math.sin(2*p21);
  cl+=     66*Math.sin(2*p19-6*p22);
  cl+=     60*pt*Math.cos(2*p19-5*p22);
  cl+=     41*Math.sin(p19-3*p22);
  cl+=     39*Math.sin(3*p22);
  cl+=     31*Math.sin(p19-p22);
  cl+=     31*Math.sin(2*p19-2*p22);
  cl-=     29*Math.cos(2*p19-3*p22);
  cl-=     28*Math.sin(2*p19-6*p22+3*p25);
  cl+=     28*Math.cos(p19-3*p22);
  cl+=     22*pt*Math.sin(2*p19-4*p22);
  cl-=     22*Math.sin(p22-3*p25);
  cl+=     20*Math.sin(2*p19-3*p22);
  cl+=     20*Math.cos(4*p19-10*p22);
  cl+=     19*Math.cos(2*p22-3*p25);
  cl+=     19*Math.sin(4*p19-10*p22);
  cl-=     17*pt*Math.cos(2*p22);
  cl-=     16*Math.cos(p22-3*p25);
  cl-=     12*Math.sin(2*p19-4*p22);
  cl+=     12*Math.cos(p19);
  cl-=     12*Math.sin(2*p22-2*p25);
  cl-=     11*pt*Math.sin(2*p22);
  cl-=     11*Math.cos(2*p19-7*p22);
  cl+=     10*Math.sin(2*p22-3*p25);
  cl+=     10*Math.cos(2*p19-2*p22);
  cl+=      9*Math.sin(4*p19-9*p22);
  cl-=      8*Math.sin(p22-2*p25);
  cl-=      8*Math.cos(2*p21+p22);
  cl+=      8*Math.cos(2*p21-p22);
  cl+=      8*Math.cos(p22-p25);
  cl-=      8*Math.sin(2*p21-p22);
  cl+=      7*Math.sin(2*p21+p22);
  cl-=      7*Math.cos(p19-2*p22);
  cl-=      7*Math.cos(2*p22);
  cl-=      6*pt*Math.sin(4*p19-10*p22);
  cl+=      6*pt*Math.cos(4*p19-10*p22);
  cl+=      6*pt*Math.sin(2*p19-6*p22);
  cl-=      5*Math.sin(3*p19-7*p22);
  cl-=      5*Math.cos(3*p19-3*p22);
  cl-=      5*Math.cos(2*p22-2*p25);
  cl+=      5*Math.sin(3*p19-4*p22);
  cl+=      5*Math.sin(2*p19-7*p22);
  cl+=      4*Math.sin(3*p19-3*p22);
  cl+=      4*Math.sin(3*p19-5*p22);
  cl+=      4*pt*Math.cos(p19-2*p22);
  cl+=      3*pt*Math.cos(2*p19-4*p22);
  cl+=      3*Math.cos(2*p19-6*p22+3*p25);
  cl-=      3*pt*Math.sin(2*p21);
  cl+=      3*pt*Math.cos(2*p19-6*p22);
  cl-=      3*pt*Math.cos(2*p21);
  cl+=      3*Math.cos(3*p19-7*p22);
  cl+=      3*Math.cos(4*p19-9*p22);
  cl+=      3*Math.sin(3*p19-6*p22);
  cl+=      3*Math.sin(2*p19-p22);
  cl+=      3*Math.sin(p19-4*p22);
  cl+=      2*Math.cos(3*p22-3*p25);
  cl+=      2*pt*Math.sin(p19-2*p22);
  cl+=      2*Math.sin(4*p22);
  cl-=      2*Math.cos(3*p19-4*p22);
  cl-=      2*Math.cos(2*p19-p22);
  cl-=      2*Math.sin(2*p19-7*p22+3*p25);
  cl+=      2*Math.cos(p19-4*p22);
  cl+=      2*Math.cos(4*p19-11*p22);
  cl-=      2*Math.sin(p22-p25);

  cb =8297*Math.sin(p22);
  cb-=3346*Math.cos(p22);
  cb+= 462*Math.sin(2*p22);
  cb-= 189*Math.cos(2*p22);
  cb+= 185;
  cb+=  79*pt*Math.cos(p22);
  cb-=  71*Math.cos(2*p19-4*p22);
  cb+=  46*Math.sin(2*p19-6*p22);
  cb-=  45*Math.cos(2*p19-6*p22);
  cb+=  29*Math.sin(3*p22);
  cb-=  20*Math.cos(2*p19-3*p22);
  cb+=  18*pt*Math.sin(p22);
  cb-=  14*Math.cos(2*p19-5*p22);
  cb-=  11*Math.cos(3*p22);
  cb-=  10*pt;
  cb+=   9*Math.sin(p19-3*p22);
  cb+=   8*Math.sin(p19-p22);
  cb-=   6*Math.sin(2*p19-3*p22);
  cb+=   5*Math.sin(2*p19-7*p22);
  cb-=   5*Math.cos(2*p19-7*p22);
  cb+=   4*Math.sin(2*p19-5*p22);
  cb-=   4*pt*Math.sin(2*p22);
  cb-=   3*Math.cos(p19-p22);
  cb+=   3*Math.cos(p19-3*p22);
  cb+=   3*pt*Math.sin(2*p19-4*p22);
  cb+=   3*Math.sin(p19-2*p22);
  cb+=   2*Math.sin(4*p22);
  cb-=   2*Math.cos(2*p19-2*p22);

  rv =9.55774;
  rv-=0.53252*Math.cos(p22);
  rv-=0.01878*Math.sin(2*p19-4*p22);
  rv-=0.01482*Math.cos(2*p22);
  rv+=0.00817*Math.sin(p19-p22);
  rv-=0.00539*Math.cos(p19-2*p22);
  rv-=0.00524*pt*Math.sin(p22);
  rv+=0.00349*Math.sin(2*p19-5*p22);
  rv+=0.00347*Math.sin(2*p19-6*p22);
  rv+=0.00328*pt*Math.cos(p22);
  rv-=0.00225*Math.sin(p22);
  rv+=0.00149*Math.cos(2*p19-6*p22);
  rv-=0.00126*Math.cos(2*p19-2*p22);
  rv+=0.00104*Math.cos(p19-p22);
  rv+=0.00101*Math.cos(2*p19-5*p22);
  rv+=0.00098*Math.cos(p19-3*p22);
  rv-=0.00073*Math.cos(2*p19-3*p22);
  rv-=0.00062*Math.cos(3*p22);
  rv+=0.00042*Math.sin(2*p22-3*p25);
  rv+=0.00041*Math.sin(2*p19-2*p22);
  rv-=0.00040*Math.sin(p19-3*p22);
  rv+=0.00040*Math.cos(2*p19-4*p22);
  rv-=0.00028*pt;
  rv-=0.00023*Math.sin(p19);
  rv+=0.00020*Math.sin(2*p19-7*p22);
}

/****************************
* uranus position cal sub 1 *
****************************/

function Uranus_cal1()
{
  cl =1296000*p24/Math.PI/2;
  cl+=  19397*Math.sin(p25);
  cl+=    570*Math.sin(2*p25);
  cl-=    536*pt*Math.cos(p25);
  cl+=    143*Math.sin(p22-2*p25);
  cl+=    110*pt*Math.sin(p25);
  cl+=    102*Math.sin(p22-3*p25);
  cl+=     76*Math.cos(p22-3*p25);
  cl-=     49*Math.sin(p19-p25);
  cl+=     32*pt*pt;
  cl-=     30*pt*Math.cos(2*p25);
  cl+=     29*Math.sin(2*p19-6*p22+3*p25);
  cl+=     29*Math.cos(2*p25-2*p28);
  cl-=     28*Math.cos(p25-p28);
  cl+=     23*Math.sin(3*p25);
  cl-=     21*Math.cos(p19-p25);
  cl+=     20*Math.sin(p25-p28);
  cl+=     20*Math.cos(p22-2*p25);
  cl-=     19*Math.cos(p22-p25);
  cl+=     17*Math.sin(2*p25-3*p28);
  cl+=     14*Math.sin(3*p25-3*p28);
  cl+=     13*Math.sin(p22-p25);
  cl-=     12*pt*pt*Math.cos(p25);
  cl-=     12*Math.cos(p25);
  cl+=     10*Math.sin(2*p25-2*p28);
  cl-=      9*Math.sin(2*p26);
  cl-=      9*pt*pt*Math.sin(p25);
  cl+=      9*Math.cos(2*p25-3*p28);
  cl+=      8*pt*Math.cos(p22-2*p25);
  cl+=      7*pt*Math.cos(p22-3*p25);
  cl-=      7*pt*Math.sin(p22-3*p25);
  cl+=      7*pt*Math.sin(2*p25);
  cl+=      6*Math.sin(2*p19-6*p22+2*p25);
  cl+=      6*Math.cos(2*p19-6*p22+2*p25);
  cl+=      5*Math.sin(p22-4*p25);
  cl-=      4*Math.sin(3*p25-4*p28);
  cl+=      4*Math.cos(3*p25-3*p28);
  cl-=      3*Math.cos(p28);
  cl-=      2*Math.sin(p28);

  cb =2775*Math.sin(p26);
  cb+= 131*Math.sin(p25-p26);
  cb+= 130*Math.sin(p25+p26);

  rv =19.21216;
  rv-= 0.90154*Math.cos(p25);
  rv-= 0.02488*pt*Math.sin(p25);
  rv-= 0.02121*Math.cos(2*p25);
  rv-= 0.00585*Math.cos(p22-2*p25);
  rv-= 0.00508*pt*Math.cos(p25);
  rv-= 0.00451*Math.cos(p19-p25);
  rv+= 0.00336*Math.sin(p22-p25);
  rv+= 0.00198*Math.sin(p19-p25);
  rv+= 0.00118*Math.cos(p22-3*p25);
  rv+= 0.00107*Math.sin(p22-2*p25);
  rv-= 0.00103*pt*Math.sin(2*p25);
  rv-= 0.00081*Math.cos(3*p25-3*p28);
}

/*****************************
* neptune position cal sub 1 *
*****************************/

function Neptune_cal1()
{
  cl =1296000*p27/Math.PI/2;
  cl+=   3523*Math.sin(p28);
  cl-=     50*Math.sin(2*p29);
  cl-=     43*pt*Math.cos(p28);
  cl+=     29*Math.sin(p19-p28);
  cl+=     19*Math.sin(2*p28);
  cl-=     18*Math.cos(p19-p28);
  cl+=     13*Math.cos(p22-p28);
  cl+=     13*Math.sin(p22-p28);
  cl-=      9*Math.sin(2*p25-3*p28);
  cl+=      9*Math.cos(2*p25-2*p28);
  cl-=      5*Math.cos(2*p25-3*p28);
  cl-=      4*pt*Math.sin(p28);
  cl+=      4*Math.cos(p25-2*p28);
  cl+=      4*pt*pt*Math.sin(p28);

  cb =6404*Math.sin(p29);
  cb+=  55*Math.sin(p28+p29);
  cb+=  55*Math.sin(p28-p29);
  cb-=  33*pt*Math.sin(p29);

  rv =30.07175;
  rv-= 0.25701*Math.cos(p28);
  rv-= 0.00787*Math.cos(2*p24-p25-2*p27);
  rv+= 0.00409*Math.cos(p19-p28);
  rv-= 0.00314*pt*Math.sin(p28);
  rv+= 0.00250*Math.sin(p19-p28);
  rv-= 0.00194*Math.sin(p22-p28);
  rv+= 0.00185*Math.cos(p22-p28);
}

/***************************
* Pluto position cal sub 1 *
***************************/

function Pluto_cal1()
{
  cl =1296000*p31/Math.PI/2;
  cl+= 101577*Math.sin(p32);
  cl+=  15517*Math.sin(2*p32);
  cl-=   3593*Math.sin(2*p33);
  cl+=   3414*Math.sin(3*p32);
  cl-=   2201*Math.sin(p32-2*p33);
  cl-=   1871*Math.sin(p32+2*p33);
  cl+=    839*Math.sin(4*p32);
  cl-=    757*Math.sin(2*p32+2*p33);
  cl-=    285*Math.sin(3*p32+2*p33);
  cl+=    227*pt*pt*Math.sin(p32);
  cl+=    218*Math.sin(2*p32-2*p33);
  cl+=    200*pt*Math.sin(p32);

  cb =57726*Math.sin(p33);
  cb+=15257*Math.sin(p32-p33);
  cb+=14102*Math.sin(p32+p33);
  cb+= 3870*Math.sin(2*p32+p33);
  cb+= 1138*Math.sin(3*p32+p33);
  cb+=  472*Math.sin(2*p32-p33);
  cb+=  353*Math.sin(4*p32+p33);
  cb-=  144*Math.sin(p32-3*p33);
  cb-=  119*Math.sin(3*p33);
  cb-=  111*Math.sin(p32+3*p33);

  rv =40.74638;
  rv-= 9.58235*Math.cos(p32);
  rv-= 1.16703*Math.cos(2*p32);
  rv-= 0.22649*Math.cos(3*p32);
  rv-= 0.04996*Math.cos(4*p32);
}

/**************************************
* pluto position cal sub 2            *
*   input  : jd = julian day          *
*   output : cl = longitude [sec,deg] *
*            cb = latitude  [sec,deg] *
*            rv = radius    [AU]      *
**************************************/

function Pluto_cal2(jd)
{
  var t;

  t=(jd-2451545.0)/36525;

  cl =241.82574;
  cl+=179.09519*t;
  cl+= 15.81087*Cosd( 246.556453*t+298.348019);
  cl+=  1.18379*Cosd( 551.34710 *t+351.67676);
  cl+=  0.07886*Cosd( 941.622   *t+ 41.989);
  cl+=  0.00861*Cosd(2836.46    *t+ 60.35);
  cl+=  0.00590*Cosd(1306.75    *t+112.91);
  cl+=  0.00145*Cosd(2488.14    *t+ 19.01);
  cl+=  0.00022*Cosd(5861.8     *t+ 77.9);
  cl+=  0.00013*Cosd(3288.8     *t+293.0);
  cl*= 3600;

  cb =17.04550*Cosd( 172.554318*t+ 42.574982);
  cb+= 2.45310*Cosd( 415.60630 *t+ 66.15350);
  cb-= 2.30285;
  cb+= 0.26775*Cosd( 713.1227  *t+105.0840);
  cb+= 0.01855*Cosd(1089.202   *t+146.660);
  cb+= 0.00119*Cosd(2658.22    *t+293.06);
  cb+= 0.00098*Cosd(3055.6     *t+ 18.8);
  cb+= 0.00090*Cosd(1532.6     *t+213.7);
  cb+= 0.00042*Cosd(2342.3     *t+254.2);
  cb*=3600;

  rv =38.662489;
  rv+= 8.670489  *Cosd( 181.3383*t+198.4973);
  rv+= 0.333884  *Cosd( 475.963 *t+228.717);
  rv+= 0.008426  *Cosd( 909.8   *t+252.9);
  rv+= 0.007619*t*Cosd(1425.9   *t+ 31.0);
  rv+= 0.004902  *Cosd(2831.6   *t+149.4);
  rv+= 0.002543*t*Cosd(2196.1   *t+199.5);
  rv+= 0.001188  *Cosd(1748.0   *t+114.1);
  rv+= 0.000390  *Cosd(3188     *t+ 15);
  rv+= 0.000116  *Cosd(5860     *t+169);
}

/******************************************************
* planet geocentric ecliptic position calculate sub   *
*   input  : jd    = julian day                       *
*   output : pcl[] = planet celestial longitude [rad] *
*            pcb[] = planet celestial latitude  [rad] *
******************************************************/

var c=new Array(8);
c[0]=0.0035; /* mercury */
c[1]=0.0048; /* venus */
c[2]=0.0071; /* mars */
c[3]=0.0129; /* jupiter */
c[4]=0.0174; /* saturn */
c[5]=0.0249; /* uranus */
c[6]=0.0312; /* neptune */
c[7]=0.0347; /* pluto */

function Planet_cal(jd)
{
  var gcl,gcb,grv, sl,sr, sx,sy, x,y,z, i;

  Get_pr1(jd); /* planet parameter cal */

  for(i=0; i<10; i++)
    {
      if(i==0) /* sun position cal */
        {
          Sun_cal1();
          gcl=cl/1296000;
          gcl=(gcl-Math.floor(gcl))*Math.PI*2;
          gcb=cb;
          sl=gcl;
          sr=rv;
          sx=rv*Math.cos(gcl);
          sy=rv*Math.sin(gcl);
          gcl-=0.0057*Math.PI/180; /* apparent longitude of sun */
        }

        else if(i==1) /* moon position cal */
        {
          Moon_cal1();
          gcl=cl*Math.PI/648000;
          gcb=cb*Math.PI/648000;
        }

        else /* planet position cal */
        {
          if(i==2)        Mercury_cal1();
            else if(i==3) Venus_cal1();
            else if(i==4) Mars_cal1();
            else if(i==5) Jupiter_cal1();
            else if(i==6) Saturn_cal1();
            else if(i==7) Uranus_cal1();
            else if(i==8) Neptune_cal1();
            else
            {
              if((jd>2432384.28546) && (jd<2479514.98634))
                     Pluto_cal2(jd);  /* 1947 - 2076 */
                else Pluto_cal1();
            }

          cl/=1296000;
          cl =(cl-Math.floor(cl))*Math.PI*2;
          cb*=Math.PI/648000;

          /* change geoocentric */
          x=rv*Math.cos(cb)*Math.cos(cl)+sx;
          y=rv*Math.cos(cb)*Math.sin(cl)+sy;
          z=rv*Math.sin(cb);
          grv=Math.sqrt(x*x+y*y+z*z);
          gcb=Math.asin(z/grv);
          gcl=Math.atan2(y,x);
          gcl-=(0.0057*Math.PI/180)/sr*Math.cos(gcl-sl)
              +(c[i-2]*Math.PI/180)/rv*Math.cos(gcl-cl);
        }

      gcl/=Math.PI*2; /* longitude normalize */
      pcl[i]=(gcl-Math.floor(gcl))*Math.PI*2;
      pcb[i]=gcb;
    }
}

/*********************
**********************
**   Main routine   **
**********************
*********************/

function disp()
{
  var iYear,iMonth,iDay,iHour,iMinute;
  var iPlace,iLonsgn,iLondeg,iLonmin,iLatsgn,iLatdeg,iLatmin;
  var iAsp=new Array(12); /* aspect orbs value [deg,min] */

  var jd; /* julian day [day] */
  var st; /* local sideral time [rad] */
  var lon; /* birthplace longitude [rad] */
  var lat; /* birthplace latitude [rad] */
  var e; /* obliquity of the ecliptic [rad] */
  var asc; /* asccendant [rad] */
  var ra; /* right ascension [rad] */
  var dc; /* declination [rad] */
  var ha; /* house angle [rad] */
  var t,tt;
  var ccl1,ccl2,ccle;
  var x,y,z,ct;
  var i,j,k;
  var si,dd,mm,buff;

  var pdc=new Array(10); /* planet declination */
  var pdm=new Array(10); /* planet dairy motion */

  var sunSign, moonSign;  // 太陽星座と月星座を保持する変数を定義


  /************************
  * Get birth date & time *
  ************************/


  iYear  =eval(document.Fin.iYear.value);
  if(iYear==null) iYear=0;
  iMonth =eval(document.Fin.iMonth.value);
  if(iMonth==null) iMonth=0;
  iDay   =eval(document.Fin.iDay.value);
  if(iDay==null) iDay=0;
  iHour  =eval(document.Fin.iHour.value);
  if(iHour==null) iHour=0;
  iMinute=eval(document.Fin.iMinute.value);
  if(iMinute==null) iMinute=0;


  /**************************************
  * Get birthplace longitude & latitude *
  **************************************/

  iPlace=eval(document.Fin.iPlace.options[document.Fin.iPlace.selectedIndex].value);
  if(iPlace==0)
    {
      iLonsgn=eval(document.Fin.iLonsgn.options[document.Fin.iLonsgn.selectedIndex].value);
      iLondeg=eval(document.Fin.iLondeg.value);
      if(iLondeg==null) iLondeg=0;
      iLonmin=eval(document.Fin.iLonmin.value);
      if(iLonmin==null) iLonmin=0;
      lon=(iLondeg+iLonmin/60)/180*Math.PI*iLonsgn;

      iLatsgn=eval(document.Fin.iLatsgn.options[document.Fin.iLatsgn.selectedIndex].value);
      iLatdeg=eval(document.Fin.iLatdeg.value);
      if(iLatdeg==null) iLatdeg=0;
      iLatmin=eval(document.Fin.iLatmin.value);
      if(iLatmin==null) iLatmin=0;
      lat=(iLatdeg+iLatmin/60)/180*Math.PI*iLatsgn;
    }
    else
    {
      lon=pLon[iPlace]/10800*Math.PI;
      lat=pLat[iPlace]/10800*Math.PI;
    }


  /*****************
  * julian day cal *
  *****************/

  if(iMonth<3)
    {
      iYear -=1;
      iMonth+=12;
    }
  t  =Math.floor(iYear/100);
  jd =Math.floor(iYear*365.25)-t+Math.floor(t/4);
  jd+=Math.floor(30.6001*(iMonth+1))+iDay+1720996.5;
  jd+=iHour/24+iMinute/1440;
  jd-=9.0/24.0; /* JST compensate */

  /********************************
  * obliquity of the ecliptic cal *
  ********************************/

  t=(jd-2451545)/36525;

  e =23.43928-0.01301*t;
  e+=0.00256*Cosd( 1934*t + 235);
  e+=0.00016*Cosd(72002*t + 201);
  e*=Math.PI/180; /* e value [rad] */

  /*************************
  * local sideral time cal *
  *************************/

  t =jd-2442412.5; /* from 1975 jan/0 0:0 */
  tt=t-Math.floor(t);
  t/=365.25;

  st =99.0361+360.00770*t+360*tt; /* greenwich sideral time get */
  st+=0.0044*Sind(-19.3*t+68.6);
  st+=0.0003*Sind(720  *t+18);

  st =st*Math.PI/180+lon; /* local sideral time get */
  st/=Math.PI*2; /* value normalize */
  st-=Math.floor(st);
  st*=Math.PI*2; /* local sideral time value [rad] */

  /****************
  * ascendant cal *
  ****************/

  x=Math.cos(st+Math.PI/2)*Math.cos(e)+Math.sin(e)/Math.tan(lat+Math.PI/2);
  y=Math.sin(st+Math.PI/2);
  asc=Math.atan2(y,x); /* ascendant celestial position [rad] */
  if(asc<0) asc+=Math.PI*2;

  /*****************
  * house casp cal *
  *****************/

  pcl[10]=asc; /* ascendant set */
  pcl[16]=asc+Math.PI; /* descandant set */

  for(i=1; i<6; i++)
    {
      ccl1=pcl[i+9]; /* min angle set */
      ccl2=asc+Math.PI; /* max angle */
      ccle=i*Math.PI/6; /* target angle */

      while(true)
        {
          cl=(ccl1+ccl2)/2;

          /* translate ecliptic to equatorial */
          x=Math.cos(cl);
          y=Math.sin(cl)*Math.cos(e);
          z=Math.sin(cl)*Math.sin(e);
          ra=Math.atan2(y,x);
          if(ra<0) ra+=Math.PI*2;
          dc=Math.asin(z);

          /* translate equatorial to placidus house angle */
          ct=-Math.tan(lat)*Math.tan(dc);
          if((ct<-1)||(ct>1))
            {
              cl=null; /* cal impossible */
              break;
            }
          tt=Math.acos(ct); /* rise & set cal */
          t=st-ra; /* hour angle cal */
          if(t<-Math.PI) t+=Math.PI*2;
            else if(t>Math.PI) t-=Math.PI*2;
          if((t>=-tt)&&(t<=tt))
            { /* above the horison */
              ha=Math.PI/2*(3-t/tt);
            }
            else
            { /* below the horison */
              t+=Math.PI;
              if(t>Math.PI) t-=Math.PI*2;
              ha=(1-t/(Math.PI-tt))*Math.PI/2;
            }
          if(ha<0) ha+=Math.PI*2; /* house angle normalize */
            else if(ha>=Math.PI*2) ha-=Math.PI*2;

          ha-=ccle;
          if(ha>0) ccl2=cl;
            else   ccl1=cl;
          if(Math.abs(ha) < 0.000001) break;
        }

      pcl[i+10]=cl;
      pcl[i+16]=cl+Math.PI;
    }

  for(i=10; i<22; i++)
    {
      if(pcl[i]>=Math.PI*2) pcl[i]-=Math.PI*2;
      pcl[i]=Math.floor(pcl[i]*10800/Math.PI);
    }

  /***************************
  * planets dairy motion cal *
  ***************************/

  Planet_cal(jd+0.5);
  for(i=0; i<10; i++) pdm[i]=pcl[i];
  Planet_cal(jd-0.5);
  for(i=0; i<10; i++)
    {
      pdm[i]-=pcl[i];
      if(pdm[i]>Math.PI) pdm[i]-=Math.PI*2;
        else if(pdm[i]< -Math.PI) pdm[i]+=Math.PI*2;
    }

  /***********************
  * planets position cal *
  ***********************/

  Planet_cal(jd);
  for(i=0; i<10; i++)
    {
      cl=pcl[i];
      cb=pcb[i];

      /* translate ecliptic to equatorial */
      z =Math.sin(cb)*Math.cos(e)+Math.cos(cb)*Math.sin(cl)*Math.sin(e);
      dc=Math.asin(z);

      pcl[i]=Math.floor(cl*10800/Math.PI);
      pdc[i]=Math.floor(dc*10800/Math.PI);
    }

  /****************
  * result output *
  ****************/

 /* body table output */
  for(i=0; i<document.Fout.oSgn.length; i++)
    {
      mm=pcl[i];
      si=Math.floor(mm/1800);
      document.Fout.oSgn[i].value=tSgn[si];
      mm-=si*1800;
      dd=Math.floor(mm/60);
      mm-=dd*60;

      if(dd<10) buff=" ";
        else buff="";
      buff+=dd.toString()+"゜";
      if(mm<10) buff+="0";
      buff+=mm.toString()+"'";
      if(i<10) if(pdm[i]<0) buff+=" R";
      document.Fout.oDeg[i].value=buff;
    }
    
    
    // 月星座と太陽星座の取得
    var sunZodiac = document.Fout.oSgn[0].value;
    var moonZodiac = document.Fout.oSgn[1].value;
    
    // 確認用にコンソール出力
    console.log("太陽星座:", sunZodiac);
    console.log("月星座:", moonZodiac);
    
    // すべての太陽星座と月星座のアイテムを非表示にする
    var allSunItems = document.querySelectorAll('.sun-item');
    allSunItems.forEach(function(sunItem) {
        sunItem.style.display = 'none';
    });
    
    var allMoonItems = document.querySelectorAll('.moon-item');
    allMoonItems.forEach(function(moonItem) {
        moonItem.style.display = 'none';
    });
    
    // 太陽星座の商品情報を表示
    if (sunZodiac) {
        var targetSun = document.querySelector('.sun-item.' + sunZodiac);
        if (targetSun) {
            // 該当する商品を表示
            targetSun.style.display = 'block';
        } else {
            console.error("対応する太陽星座の商品が見つかりません。");
        }
    } else {
        console.error("太陽星座が無効です。");
    }
    
    // 月星座の商品情報を表示
    if (moonZodiac) {
        var targetMoon = document.querySelector('.moon-item.' + moonZodiac);
        if (targetMoon) {
            // 該当する商品を表示
            targetMoon.style.display = 'block';
        } else {
            console.error("対応する月星座の商品が見つかりません。");
        }
    } else {
        console.error("月星座が無効です。");
    }


}

